<div class="form-group" [formGroup]="group">
    <label>{{field.label}}</label>
    <mat-radio-group  color="primary" [formControlName]="field.name" [ngClass]="{'custom-field-invalid': group.get(field.name).invalid}">
        <mat-radio-button *ngFor="let option of field.options" [value]="option">{{option}}</mat-radio-button>
    </mat-radio-group>

    <app-error-validation-messages [group]="group" [field]="field"></app-error-validation-messages>

</div>
